<template>
  <div class="help-card">
    <nuxt-link :to="titleLink || link" :target="target" class="help-card__header">
      <XTag v-if="data?.is_new" type="new" size="large" class="help-card__tag" />
      <div class="help-card__title" v-html="data.display_title?.highlight_text"></div>
    </nuxt-link>
    <div class="help-card__content">
      <AudioItem
        v-if="data.audio_url"
        :data="data"
        class="help-card__media help-card__media--audio"
      />
      <div
        v-else-if="data.image_url || data.video_url"
        class="help-card__media"
        :class="{
          'help-card__media--image': isImage,
          'help-card__media--video': isVideo,
        }"
        @click.stop="showMedia(data.video_url || data.image_url)"
      >
        <HoverVideo
          v-if="data.video_url"
          class="help-card__media-video"
          :data="{
            cover_url: data.video_cover_url || data?.cover_url,
            hover_video: preview_video || data.video_url,
          }"
        >
        </HoverVideo>
        <Resource
          v-else-if="data.image_url"
          :src="data.image_url"
          class="help-card__media-image"
          :transformResource="transformImage"
        />
        <div v-if="isImage" class="help-card__media-icon">
          <iconpark-icon name="zoom-g727dgpm" size="16"></iconpark-icon>
        </div>
      </div>
      <nuxt-link :to="descLink || link" :target="target">
        <div class="help-card__desc-wrapper">
          <div class="help-card__desc" v-html="data?.display_content?.highlight_text"></div>
        </div>
      </nuxt-link>
    </div>
    <slot name="other" />
  </div>
</template>

<script lang="ts" setup>
import type { IHelpSearch } from '~/api/module/help-center';
import { usePlayView } from '~/features/pageList/index';
import HoverVideo from '../hoverVideo/index.vue';
import AudioItem from './audio.vue';
const props = defineProps<{
  data: IHelpSearch;
  preview_video?: string;
  titleLink?: object; // 标题跳转链接
  descLink?: object; // 描述跳转链接
  link?: object; // 整体跳转链接
  target?: string;
}>();

const isVideo = computed(() => props.data.video_url);
const isImage = computed(() => props.data.image_url);

const showMedia = (url?: string) => {
  usePlayView({ file_url: url });
};
</script>

<style lang="scss" scoped>
// 帮助卡片容器
.help-card {
  border-radius: 8px;
}

// 头部区域
.help-card__header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 5px;
}

// 新标签
.help-card__tag {
  position: absolute;
  left: 8px;
  top: 8px;
  z-index: 10;
}

// 标题
.help-card__title {
  font-size: 18px;
  font-weight: bold;
  color: var(--text-font-1);
}

// 内容区域
.help-card__content {
  display: flex;
  gap: 20px;
}

// 媒体容器
.help-card__media {
  height: 63px;
  width: 112px;
  flex-shrink: 0;
  position: relative;
}

// 音频媒体
.help-card__media--audio {
  height: 63px;
  width: 112px;
  flex-shrink: 0;
}

// 视频组件
.help-card__media-video {
  height: 60px;
  position: absolute;
}

// 图片
.help-card__media-image {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  cursor: pointer;
}

// 媒体图标
.help-card__media-icon {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  height: 24px;
  width: 24px;
  padding: 4px;
}

// 图片悬停时显示图标
.help-card__media--image:hover .help-card__media-icon {
  display: block;
}

// 描述包装器
.help-card__desc-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  line-height: 26px;
}

// 描述文本
.help-card__desc {
  color: var(--text-1-80);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
